module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAATxJREFUSEvtlkFKw0AUhr+XSdoD6MKNCz2BmyxaBb2AoCfRo+hJ9AKFCtIiRXDjQrd10UXdFmoyGRmhkIQ0IWNSRJpdmLx88783b/4nACZkj4AD7bFr310elTBHM5UnPsrixcJ0l9AFUhSjlkxkwmzd/yTq0RfFTlNAo/kMxozWAuMTzosWjSYywizwWNTdjDzyXguYJEyDJa/yTFQXVvW95BVaWGfES1Wg63oGaNPofzFoQ9lqgxlgkTrT40J7XAmcuaoyMFQJtzLmPgNU8JYuuIUlHneuoHycl3BZCoz7DEU4bQpoDA+lQH2MaQpWWMN8SrdAl3Rva/gPTmnaDzfSFouQ/U6XI3viNgJczTSxz6GvmKfv0lYav6yXtkCnm+ZPpbQVPyxT2IrjV9XhZ6YRrn/j/NbpleHGzjTfCxezUmQ22U8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/cope.png
// module id = hakY
// module chunks = 1